import { render, staticRenderFns } from "./AddWinery2Registration.vue?vue&type=template&id=38dcf0c5&scoped=true&"
import script from "./AddWinery2Registration.vue?vue&type=script&lang=js&"
export * from "./AddWinery2Registration.vue?vue&type=script&lang=js&"
import style0 from "./AddWinery2Registration.vue?vue&type=style&index=0&id=38dcf0c5&prod&scoped=true&lang=css&"
import style1 from "./AddWinery2Registration.vue?vue&type=style&index=1&id=38dcf0c5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dcf0c5",
  null
  
)

export default component.exports